import { Component, OnInit, OnDestroy } from '@angular/core';
import { StateComponent } from '../state-component.interface';
import { Usdm2Service } from '../../../../services/ai/usdm2.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-epochs-visits',
  imports: [],
  templateUrl: './epochs-visits.component.html',
  styleUrl: './epochs-visits.component.css'
})
export class EpochsVisitsComponent implements StateComponent, OnInit, OnDestroy {
  stateName = 'Epochs & Visits';
  private usdmSub: Subscription | null = null;
  // eslint-disable-next-line
  data:any = null;

  constructor(private usdm: Usdm2Service) { }

  ngOnInit(): void {
    this.usdmSub = this.usdm.contentUpdate$.subscribe((item) => {
      if (this.usdm.currentState() == this.stateName && item && item.type === 'OsbUploadResponse') {
        if (item.message.includes('Uploading epochs and visits to OSB...')) {
          this.data = item.data;
          this.usdm.signalStateCompletion(this.stateName);
        }
      }
    });
  }

  ngOnDestroy(): void {
    this.usdmSub?.unsubscribe();
    this.usdmSub = null;
  }

}
